(function(){
     'use strict';

     angular
        .module('appback')
        .factory('FacturacionService', FacturacionService);

    FacturacionService.$inject = ['$http'];

    function FacturacionService($http){

        var service= {
           getFacturasCentro:getFacturasCentro
        };

        return service;
 		function getFacturasCentro(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getfacturascentro', { params : { filtros : filtros } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();